import { render, staticRenderFns } from "./BakingIngredients.vue?vue&type=template&id=3bacbe0e&scoped=true&"
import script from "./BakingIngredients.vue?vue&type=script&lang=js&"
export * from "./BakingIngredients.vue?vue&type=script&lang=js&"
import style0 from "./BakingIngredients.vue?vue&type=style&index=0&id=3bacbe0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bacbe0e",
  null
  
)

export default component.exports